<template>
  <div class="content">
    <el-tabs class="tabLv3 historAlarm" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 无人机监测
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1 alarmSearchForm">
          <el-form>
            <el-form-item label="设备编号">
              <el-input
                v-model="searchForm.deviceId"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            stripe
          >
            <el-table-column
              show-overflow-tooltip
              v-for="{ prop, label } in tableLable"
              :key="prop.toString()"
              :label="label"
              :prop="prop"
              :render-header="labelHead"
            >
            </el-table-column>
            <el-table-column label="操作" width="200" align="left">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconwhole"
                  type="text"
                  size="small"
                  @click="openDetailDialog(scope.row)"
                  >详情</el-link
                >
                <el-link
                  icon="iconfont iconcheck"
                  type="text"
                  size="small"
                  @click="openFilingDialog(scope.row)"
                  v-if="scope.row.status == 0"
                  >报备</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              v-if="flagShow"
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 报备弹窗 -->
    <el-dialog
      title="告警报备"
      :visible.sync="filingDialogVisible"
      width="600px"
      :before-close="closeFilingDialog"
    >
      <el-form :model="filingForm" :rules="filingRules" ref="filingForm">
        <el-form-item label="报备原因类型" prop="reasonType">
          <el-select
            v-model="filingForm.reasonType"
            placeholder="请选择报备原因类型"
          >
            <el-option
              v-for="item in reasonTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报备描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入报备描述"
            v-model="filingForm.description"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFilingDialog">取 消</el-button>
        <el-button type="primary" @click="submitFiling">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      title="报备详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      :before-close="closeDetailDialog"
      class="detailDialog"
    >
      <el-form :model="detailForm" size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="设备id">
              <span>{{ detailForm.deviceId || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="通道">
              <span>{{ detailForm.channel || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="信号强度">
              <span>{{ detailForm.rssi || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="序列号">
              <span>{{ detailForm.serialNumber || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="无人机经度">
              <span>{{ detailForm.uavLon || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="无人机纬度">
              <span>{{ detailForm.uavLat || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="无人机反航点经度">
              <span>{{ detailForm.uavReturnLon || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="无人机反航点纬度">
              <span>{{ detailForm.uavReturnLat || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="操作员经度">
              <span>{{ detailForm.droneOperatorLon || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="操作员纬度">
              <span>{{ detailForm.droneOperatorLat || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="高度">
              <span>{{ detailForm.height || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="海拔">
              <span>{{ detailForm.altitude || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="速度">
              <span>{{ detailForm.speed || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="时间">
              <span>{{ detailForm.time || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="上报频率">
              <span>{{ detailForm.reportFreq || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="距离设备距离">
              <span>{{ detailForm.duration || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { formatDate } from "utils";
export default {
  data() {
    return {
      className: "collapse",
      tabName: "jsgl",
      searchForm: {
        deviceId: "",
        startTime: "",
        endTime: ""
      },
      gradeOptions: [
        { name: "未报备", value: 0 },
        { name: "已报备", value: 1 }
      ],
      showTable: true,
      tableLable: [
        {
          prop: "deviceId",
          label: "设备编号"
        },
        {
          prop: "create_time",
          label: "开始时间"
        }
      ],
      nTotal: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      flagShow: true,
      // 报备弹窗相关数据
      filingDialogVisible: false,
      currentRow: null,
      filingForm: {
        reasonType: "",
        description: ""
      },
      reasonTypeOptions: [],
      filingRules: {
        reasonType: [
          { required: true, message: "请选择报备原因类型", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入报备描述", trigger: "blur" }
        ]
      },
      // 详情弹窗相关数据
      detailDialogVisible: false,
      detailForm: {}
    };
  },
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfoDate(val, this.pagesize);
    },
    // 获取后台数据
    getInfoDate(page, pagesize) {
      let formData = JSON.parse(JSON.stringify(this.searchForm));
      this.$axiospost("operation/djiDroneHistoryReportData/queryList", {
        ...formData,
        pageNum: page,
        pageSize: pagesize
      }).then(res => {
        this.tableData = res.data.data.list;
        this.nTotal = res.data.data.total;
        this.flagShow = true;
      });
    },
    // 表头全显
    labelHead(h, { column, index }) {
      let l = column.label.length;
      let f = 21; //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * l; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度 //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("div", { class: "table-head", style: { width: "100%" } }, [
        column.label
      ]);
    },

    reset() {
      this.searchForm = {
        deviceMark: "",
        deviceName: "",
        unitName: "",
        districtName: "",
        status: ""
      };
      this.currentPage = 1;
    },
    subSeefrom() {
      this.flagShow = false;
      this.getInfoDate(this.currentPage, this.pagesize);
    },
    // 打开报备弹窗
    openFilingDialog(row) {
      this.currentRow = row;
      this.filingForm = {
        reasonType: "",
        description: ""
      };
      this.filingDialogVisible = true;
    },

    // 关闭报备弹窗
    closeFilingDialog() {
      this.filingDialogVisible = false;
      this.filingForm = {
        reasonType: "",
        description: ""
      };
      this.$refs.filingForm && this.$refs.filingForm.resetFields();
    },

    // 提交报备
    submitFiling() {
      this.$refs.filingForm.validate(valid => {
        if (valid) {
          // 发送请求更新报备信息
          this.$axiospost("operation/deviceAlarmReport/update", {
            id: this.currentRow.id,
            reasonType: Number(this.filingForm.reasonType),
            description: this.filingForm.description,
            status: 1 // 可能需要设置为报备状态
          })
            .then(res => {
              if (res.data.status === "10000") {
                this.$message.success("报备成功");
                this.closeFilingDialog();
                // 刷新列表
                this.getInfoDate(this.currentPage, this.pagesize);
              } else {
                this.$message.error("报备失败：" + res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("报备失败：" + err.message);
            });
        } else {
          console.log("验证失败!");
          return false;
        }
      });
    },
    // 打开详情弹窗
    openDetailDialog(row) {
      this.detailForm = { ...row }; // 复制行数据到详情表单
      this.detailForm.time=formatDate(new Date(Number(row.time)))
      this.detailDialogVisible = true;
    },

    // 关闭详情弹窗
    closeDetailDialog() {
      this.detailDialogVisible = false;
      this.detailForm = {};
    }
  },
  mounted() {
    this.getInfoDate(this.currentPage, this.pagesize);
    this.$axiosget("/operation/dictionaryData/queryByKey", {
      params: {
        key: "alarmReportReasonType"
      }
    }).then(res => {
      this.reasonTypeOptions = res.data.data;
    });
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form .el-form-item__label {
  width: 120px;
}
/deep/.el-form .el-form-item__content {
  margin-left: 40px;
}
/deep/.detailDialog .el-form .el-form-item__label {
  width: 140px;
}
/deep/.detailDialog .el-form .el-form-item__content {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/alarm/droneAlarm.vue